/* eslint-disable react/style-prop-object */
import React, { useContext, useEffect, useRef } from "react";
import ObjectTableHead from "./ObjectTableHead";
import ObjectTableBody from "./ObjectTableBody";
import { filtrationcontext } from "../../../../context/Filtercontext";
import { useLocation } from "react-router-dom";
import ObjectTableBodyGroups from "./ObjectTableBodyGroups";
export default function ObjectTable({ type }) {
	let {
		setFilter,
		setIsFilterTriggered,
		setChecked,
		setChildCheck,
		setParentCheck,
		filter,
		parentCheck,
	} = useContext(filtrationcontext);
	let { pathname } = useLocation();
	const filterRef = useRef(filter);

	useEffect(() => {
		filterRef.current = filter; // keep it updated with latest value
	}, [filter]);
	useEffect(() => {
		if (pathname !== "/livetracking") {
			setFilter(false);
			setIsFilterTriggered(false);
			setChecked([]);
			setChildCheck([]);
			setParentCheck([]);
		}
		return () => {
			if (filterRef.current) {
				setIsFilterTriggered(true);

				// Do nothing to preserve state
			} else {
				setFilter(false);
				setIsFilterTriggered(false);
				setChecked([]);
				setChildCheck([]);
				setParentCheck([]);
			}
		};
	}, []);
	return (
		<>
			<ObjectTableHead type={type} />
			<div className="object-table-body ">
				<ObjectTableBodyGroups type={type} />
			</div>
		</>
	);
}
